module.exports = __webpack_public_path__ + "img/lightbox-close.a15226fd.svg";